import { fmtUsd, fmtPrice } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Warning, Lightning, ShieldCheck } from "@phosphor-icons/react";

export default function LiveTradeDialog({ open, onOpenChange, candidate, config, solStatus, onConfirm, submitting }) {
  if (!candidate) return null;
  const configured = solStatus?.configured;
  const sec = candidate.security;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#09090b] border-[#27272a] rounded-none max-w-md" data-testid="live-trade-dialog">
        <DialogHeader>
          <DialogTitle className="font-head font-semibold tracking-tight flex items-center gap-2">
            <Lightning weight="fill" className="text-red-400" size={18} /> Confirm LIVE Trade
          </DialogTitle>
        </DialogHeader>

        <div className="flex items-start gap-2 text-[11px] text-red-400 font-mono border border-red-500/30 bg-red-500/5 p-2.5">
          <Warning size={16} className="mt-0.5 shrink-0" />
          This sends a REAL on-chain swap from the dedicated bot wallet (SOL → {candidate.symbol}) via Jupiter. Funds move for real.
        </div>

        <div className="border border-[#27272a] divide-y divide-[#1f1f22]">
          {[
            ["Token", `${candidate.symbol} · ${candidate.chain}`],
            ["Price", fmtPrice(candidate.price)],
            ["Size (risk/trade)", `$${config?.risk_per_trade}`],
            ["Take Profit", `$${config?.tp_target_usd}`],
            ["Stop Loss", `$${config?.stop_loss_usd} (manual close — no auto-exit on live)`],
            ["Slippage", "1.0% (LIVE_SLIPPAGE_BPS)"],
            ["Confidence", `${candidate.confidence}/100`],
          ].map(([k, v]) => (
            <div key={k} className="flex items-center justify-between px-3 py-1.5 text-xs">
              <span className="text-[#a1a1aa]">{k}</span>
              <span className="font-mono text-[#f4f4f5] text-right">{v}</span>
            </div>
          ))}
        </div>

        {sec?.available && (
          <div className="flex items-center gap-1.5 text-[11px] font-mono text-green-400">
            <ShieldCheck size={13} /> GoPlus: {sec.honeypot ? <span className="text-red-400">honeypot risk!</span> : "no critical flags"}
            {sec.warnings?.length ? <span className="text-yellow-400"> ({sec.warnings.join(", ")})</span> : null}
          </div>
        )}

        {!configured && (
          <div className="flex items-start gap-2 text-[11px] text-yellow-400 font-mono border border-yellow-500/30 bg-yellow-500/5 p-2.5" data-testid="live-not-configured">
            <Warning size={14} className="mt-0.5 shrink-0" />
            Wallet not configured. Add BOT_PRIVATE_KEY_B58 & JUPITER_API_KEY to backend .env, then restart backend to enable live execution.
          </div>
        )}

        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}
            className="rounded-none border-[#27272a] bg-transparent hover:bg-[#18181b]">Cancel</Button>
          <Button data-testid="confirm-live-btn" disabled={!configured || submitting} onClick={onConfirm}
            className="rounded-none bg-red-600 hover:bg-red-500 text-white font-semibold active:scale-95 disabled:opacity-40">
            {submitting ? "EXECUTING…" : "EXECUTE LIVE"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
